<template>
    <v-card class="pa-2 pb-3">
        <v-card-title class="headline px-3">Add Payments</v-card-title>

        <div v-if="!showConfirmView">
            <v-card style="background-color: #5cb860" class="mt-2 mx-3">
                <v-layout row>
                    <div
                        class="pa-3 pt-4 mt-1 display-1 font-weight-light"
                        style="width: 24%; color: #fff"
                    >
                        Default Values
                    </div>
                    <v-card-actions
                        class="pb-0 my-2 mx-3"
                        style="width: 74%; background-color: #fff; border-radius: 3px;"
                    >
                        <v-layout row>
                            <v-text-field
                                style="width: 15%;"
                                class="mr-2 ml-4"
                                label="Amount"
                                placeholder="Amount"
                                v-model="amount"
                                @input="updateAmount"
                                type="number"
                                prefix="$"
                            ></v-text-field>
                            <v-select
                                style="width: 20%;"
                                class="mr-2"
                                :items="paymentTypes"
                                label="Payment Type"
                                v-model="paymentType"
                                @change="updatePaymentType"
                                hide-details
                            ></v-select>
                            <v-menu
                                v-model="datePickerMenu"
                                :close-on-content-click="true"
                                offset-y
                                full-width
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        style="width: 20%;"
                                        class="mx-2"
                                        v-model="date"
                                        :value="date"
                                        label="Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        hide-details
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="date"
                                    @change="updateDate"
                                ></v-date-picker>
                            </v-menu>
                            <v-combobox
                                style="width: 20%;"
                                class="mr-1"
                                hide-details
                                label="Note"
                                :items="noteOptions"
                                @input="updateNote"
                                v-model="note"
                            ></v-combobox>
                            <v-checkbox
                                style="width: 15%;"
                                class="mx-1"
                                label="Confirmed"
                                color="success"
                                hide-details
                                @change="updateConfrimed"
                                v-model="confirmed"
                            ></v-checkbox>
                        </v-layout>
                    </v-card-actions>
                </v-layout>
            </v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-2 mt-3 scroll mx-2" style="height: 500px;">
                <div
                    class="headline font-weight-regular mb-4 text-xs-center"
                    v-if="!students.length"
                >
                    Please select students
                </div>
                <div v-for="(student, index) in students" class="student-line">
                    <v-layout row class="mb-2 mt-0">
                        <!-- <div
                            style="width: 25%; text-align: right;"
                            class="mt-3 mr-3"
                        >
                            {{ student.fullName }}
                        </div> -->
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <v-text-field
                            style="width: 15%;"
                            class="mx-2 pt-4 amount"
                            label="Amount"
                            v-model="student.amount"
                            type="number"
                            ref="amount"
                            @input="student.amountFound = student.amount"
                            prefix="$"
                        ></v-text-field>
                        <v-text-field
                            style="width: 15%;"
                            class="mx-2 pt-4"
                            label="Amount Found"
                            v-model="student.amountFound"
                            :rules="[
                                v => !!v || 'Required',
                                value => amountFoundRule(value, student)
                            ]"
                            type="number"
                            ref="amountFound"
                            prefix="$"
                        ></v-text-field>
                        <v-select
                            style="width: 20%;"
                            class="mx-2 pt-4"
                            :items="paymentTypes"
                            label="Payment Type"
                            v-model="student.paymentType"
                            :rules="required"
                            ref="paymentType"
                            hide-details
                        ></v-select>
                        <v-menu
                            v-model="student.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    style="width: 20%;"
                                    class="mx-2 pt-4"
                                    v-model="student.date"
                                    :value="student.date"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    hide-details
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="student.date"
                            ></v-date-picker>
                        </v-menu>
                        <v-combobox
                            style="width: 20%;"
                            class="mx-2 pt-4"
                            hide-details
                            label="Note"
                            :items="noteOptions"
                            v-model="student.note"
                        ></v-combobox>
                        <v-checkbox
                            style="width: 15%;"
                            class="mx-2 pt-4"
                            label="Confirmed"
                            color="success"
                            hide-details
                            v-model="student.confirmed"
                        ></v-checkbox> </v-layout
                    ><v-divider
                        class="mt-0 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn
                    :disabled="
                        !students.length || !students.some(s => s.amount)
                    "
                    :loading="processing"
                    color="success"
                    @click="continueToConfirm()"
                >
                    Continue
                </v-btn>
            </v-card-actions>
        </div>

        <div v-else>
            <div
                class="headline font-weight-regular text-warning mb-4 text-xs-center"
            >
                Please confirm payment details below
            </div>
            <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
                <div
                    height="50"
                    v-for="(student, index) in students.filter(s => +s.amount)"
                >
                    <v-layout row class="font-weight-regular">
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <div
                            style="width: 20%; text-align: right;"
                            class="mx-3 text-xs-center"
                            v-bind:class="{
                                'pt-4': !getMissingAmount(student),
                                'pt-1': getMissingAmount(student)
                            }"
                        >
                            {{ student.amount | currency }}
                            <div
                                v-if="getMissingAmount(student)"
                                class="text-danger pt-2"
                            >
                                Missing:
                                {{ getMissingAmount(student) | currency }}
                            </div>
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.paymentType }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.date | date }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{
                                student.confirmed
                                    ? "Confirmed"
                                    : "Not Confirmed"
                            }}
                        </div>
                    </v-layout>
                    <v-divider
                        class="mt-2 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn dark color="default" @click="showConfirmView = false"
                    >Back</v-btn
                >
                <v-btn :loading="processing" color="success" @click="save()">
                    Save Payments
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    props: {
        students: Array,
        reloadGrid: Function,
        closeNewPaymentDialog: Function,
        getDomain: Function,
        setup: Object
    },
    components: {},
    data() {
        return {
            processing: false,
            showConfirmView: false,
            datePickerMenu: false,
            amount: "",
            date: toISOLocal(new Date(moment())).substr(0, 10),
            confirmed: true,
            note: "",
            paymentType: "Cash",
            paymentTypes: ["Cash", "Check", "Credit"],

            noteOptions: [
                "In office for Y.B.",
                "In office for A.H.M.",
                "Money not found",
                "By the menahl"
            ],

            required: [v => !!v || "Required"],
            amountFoundRule: (value, student) => {
                return (
                    !value ||
                    value <= +student.amount ||
                    "Must be less or equal to amount"
                );
            }
        };
    },
    async created() {},
    mounted() {
        window.addEventListener("keypress", this.handleEnterKey);
    },
    beforeDestroy() {
        window.removeEventListener("keypress", this.handleEnterKey);
    },
    watch: {},
    computed: {},
    methods: {
        handleEnterKey(event) {
            if (event.which == 13) {
                const nextElement = event.target.closest(".student-line")
                    .nextSibling;

                if (nextElement) {
                    nextElement.querySelector("input").focus();
                }
            }
        },
        closeDialog() {
            this.amount = "";
            this.paymentType = "Cash";
            this.confirmed = true;
            this.note = "";
            this.date = toISOLocal(new Date(moment())).substr(0, 10);
            this.showConfirmView = false;

            this.closeNewPaymentDialog();
        },
        updateAmount(value) {
            this.students.forEach(student => (student.amount = value));
            this.students.forEach(
                student => (student.amountFound = student.amount)
            );
        },
        updatePaymentType(value) {
            this.students.forEach(student => (student.paymentType = value));
        },
        updateNote(value) {
            this.students.forEach(student => (student.note = value));
        },
        updateConfrimed(value) {
            this.students.forEach(student => (student.confirmed = value));
        },
        updateDate(value) {
            this.students.forEach(student => (student.date = value));
        },
        validate() {
            // const amountValidation = this.$refs.amount
            //     .map(a => a.validate(true))
            //     .every(Boolean);
            const paymentTypeValidation = this.$refs.paymentType
                .map(a => a.validate(true))
                .every(Boolean);

            return [paymentTypeValidation].every(Boolean);
        },
        continueToConfirm() {
            if (!this.validate()) return;

            this.showConfirmView = true;
        },
        getMissingAmount(student) {
            return student.amount - student.amountFound;
        },
        async save() {
            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            const data = this.students
                .filter(s => +s.amount)
                .map(student => {
                    return {
                        transactionID: 0,
                        year: this.setup.currentYear,
                        date: student.date,
                        enteredOn: today,
                        amount: student.amount,
                        missingAmount: this.getMissingAmount(student),
                        confirmed: student.confirmed,
                        studentID: student.studentID,
                        note: student.note,
                        paymentType: student.paymentType,
                        entreredBY: this.$store.state.authentication.user
                    };
                });

            try {
                await this.$http.post(
                    this.getDomain() + "/api/transactions/postInBulk",
                    data
                );

                this.processing = false;

                this.$notify({
                    text: "Payments Saved",
                    group: "notification",
                    type: "success"
                });

                this.closeDialog();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        }
    }
};
</script>
<style>
.scroll {
    overflow-y: auto;
}
</style>
